(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-component.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-component.js');

'use strict';

const {
  paymentTypes
} = svs.accountservicesReact.deposit.constants;
const {
  DropdownSelectItem,
  DropdownItem,
  DropdownLabel
} = svs.ui.ReactDropdown;
const {
  ReactBank: Bank,
  ReactIcon: Icon
} = svs.ui;
const {
  useEffect,
  useRef,
  useState
} = React;
const {
  selectedDepositMethodChange,
  instantPayChange
} = svs.accountservicesReact.deposit.store.deposit.actions;
const {
  DepositLimits
} = svs.accountservicesReact.deposit.depositLimits;
const {
  LoaderPanel
} = svs.accountservicesReact.deposit;
const {
  BlockInfo
} = svs.accountservicesReact.deposit.depositBlock;
const {
  InlineMessage
} = svs.components.tb_ui_react.inlineMessage;
const {
  SwedbankExpress
} = svs.accountservicesReact.deposit.swedbankExpress;
const {
  BankCard
} = svs.accountservicesReact.deposit.bankCard;
const {
  ApplePay
} = svs.accountservicesReact.deposit.applePay;
const {
  Swish
} = svs.accountservicesReact.deposit.swish;
const {
  WithdrawalInfo
} = svs.accountservicesReact.deposit.depositShared;
const {
  DepositCcWarning
} = svs.accountservicesReact.deposit.depositShared;
const {
  amountLimits
} = svs.accountservicesReact.deposit.constants;
const DepositComponent = _ref => {
  var _svs$accountservicesR, _blockInfo$depositRes;
  let {
    instantPay = {},
    hasNoProfileLinkSwish,
    isHideDepositLimits,
    isPlayerRegistration = false,
    swedbankPayProps
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [blockInfo, setBlockInfo] = useState(null);
  const [isCheckBlock, setIsCheckBlock] = useState(true);
  const {
    setLastDepositMethodAsync
  } = svs.accountservicesReact.deposit.helpers.sharedHelpers;
  const isShowApplePay = svs.core.detect.browser.safari() && (svs.core.detect.os.iOS() || svs.core.detect.os.osX());
  const getBlockingInfo = svs.accountservicesReact.deposit.helpers.blockingInfoHelper.getBlockingInfo;
  const isTransactionsLimitsSet = ((_svs$accountservicesR = svs.accountservicesReact.deposit) === null || _svs$accountservicesR === void 0 || (_svs$accountservicesR = _svs$accountservicesR.data) === null || _svs$accountservicesR === void 0 || (_svs$accountservicesR = _svs$accountservicesR.transactionLimits) === null || _svs$accountservicesR === void 0 ? void 0 : _svs$accountservicesR.limitsIsSet) || false;
  const reduxInstantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const selectedDepositMethod = ReactRedux.useSelector(state => state.deposit.selectedDepositMethod);
  const bankCardComponentRef = useRef(null);
  const applePayComponentRef = useRef(null);
  const maxLimitRemainingStr = ReactRedux.useSelector(state => {
    var _state$deposit$maxLim;
    return (_state$deposit$maxLim = state.deposit.maxLimits) === null || _state$deposit$maxLim === void 0 ? void 0 : _state$deposit$maxLim.spendLimitRemaining;
  }) || '1000000,00';
  const maxLimitRemaining = parseInt(maxLimitRemainingStr, 10);
  const showCreditcardBan = svs.core.detect.feature('ft-cc-ban-text-bankcard-applepay');
  if (!reduxInstantPay) {
    dispatch(instantPayChange(instantPay));
  } else {
    instantPay = reduxInstantPay;
  }

  if (!selectedDepositMethod) {
    dispatch(selectedDepositMethodChange(paymentTypes.SWISH));
  }
  const handleSelect = async (paymentName, instantPay) => {
    await setLastDepositMethodAsync(paymentName);
    if (instantPay) {
      dispatch(instantPayChange(instantPay));
    }
    dispatch(selectedDepositMethodChange(paymentName));
  };
  const handleSelectAndTrack = paymentName => {
    handleSelect(paymentName);
    const previousPaymentMethod = selectedDepositMethod;
    const trackSwitchMainPayment = function () {
      let paymentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown';
      svs.components.analytics.trackEvent({
        category: 'Deposits',
        action: 'Deposit Cancel Dropdown',
        opt_label: paymentType
      });
    };
    if (previousPaymentMethod === paymentTypes.SWISH && paymentName !== paymentTypes.SWISH) {
      trackSwitchMainPayment('Swish');
    } else if (previousPaymentMethod === paymentTypes.APPLEPAY && paymentName !== paymentTypes.APPLEPAY) {
      trackSwitchMainPayment('CC ApplePay');
      if (applePayComponentRef.current) {
        applePayComponentRef.current.cleanUpSwedbankPayOnDropdownChange();
      }
    } else if (previousPaymentMethod === paymentTypes.BANKCARD && paymentName !== paymentTypes.BANKCARD) {
      trackSwitchMainPayment('CC');
      if (bankCardComponentRef.current) {
        bankCardComponentRef.current.cleanUpSwedbankPayOnDropdownChange();
      }
    } else if (previousPaymentMethod === paymentTypes.SWEDBANKEXPRESS && paymentName !== paymentTypes.SWEDBANKEXPRESS) {
      trackSwitchMainPayment('SwedbankExpress');
    }
  };
  useEffect(() => {
    const checkIfBlocked = async () => {
      const blockingInfo = await getBlockingInfo(maxLimitRemaining);
      setBlockInfo(blockingInfo);
      if (!blockingInfo) {
        handleSelect(selectedDepositMethod);
      }
    };
    if (isCheckBlock || maxLimitRemaining < amountLimits.MIN) {
      checkIfBlocked();
      setIsCheckBlock(false);
    }

  }, [isCheckBlock, maxLimitRemaining]);
  const onBoardingUrl = "".concat(svs.core.urlMapping.get('transactionsHome'), "/komplettera-uppgifter");
  const depositLimitsUrl = "".concat(onBoardingUrl, "/insattningsgranser?setLimits=true&returnUrl=").concat(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('transactionsHome')));
  const isSetLimits = Boolean(svs.utils.url.queryString.setLimits);


  const trackButtonToDepositLimits = () => {
    svs.components.analytics.trackEvent({
      category: 'set_deposit_limit_page_insattning',
      action: 'click_set_deposit_limit'
    });
  };
  const handleNavigateToDepositLimits = () => {
    trackButtonToDepositLimits();
    svs.utils.url.navigate(depositLimitsUrl);
  };
  const headingText = () => {
    var _instantPay;
    if (instantPay.product === 'spela-tillsammans') {
      return 'Sätt in och för över till laget';
    }
    if ((_instantPay = instantPay) !== null && _instantPay !== void 0 && _instantPay.isDepositAndPay) {
      return 'Sätt in och betala spelet';
    }
    return 'Sätt in pengar på spelkontot';
  };
  return React.createElement("div", null, (isTransactionsLimitsSet || isHideDepositLimits) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "transaction-deposit"
  }, blockInfo === null && React.createElement(LoaderPanel, null), blockInfo && React.createElement(BlockInfo, {
    blockInfo: blockInfo,
    setIsCheckBlock: setIsCheckBlock
  }), blockInfo !== null && !blockInfo && React.createElement(React.Fragment, null, !isPlayerRegistration && !isSetLimits && React.createElement("h2", {
    className: "h3 margin-v-1 f-center"
  }, headingText()), showCreditcardBan && (selectedDepositMethod === paymentTypes.BANKCARD || selectedDepositMethod === paymentTypes.APPLEPAY) && React.createElement(DepositCcWarning, null), React.createElement(DropdownSelectItem, {
    branding: "transaction-deposit",
    className: "js-dropdown-deposit drop-down-deposit",
    defaultText: "Hur vill du s\xE4tta in?",
    onSelect: handleSelectAndTrack,
    selectLabel: isPlayerRegistration ? '' : 'Välj insättningsmetod',
    v2: true
  }, React.createElement(DropdownItem, {
    name: paymentTypes.SWISH,
    selected: selectedDepositMethod === paymentTypes.SWISH
  }, React.createElement(Bank, {
    className: "bank-container",
    height: 24,
    name: "swish"
  })), isShowApplePay ? React.createElement(DropdownItem, {
    name: paymentTypes.APPLEPAY,
    selected: selectedDepositMethod === paymentTypes.APPLEPAY
  }, React.createElement(Bank, {
    className: "bank-container",
    height: 24,
    name: "apple-pay"
  }), React.createElement(DropdownLabel, null, "Apple Pay")) :
  React.createElement(React.Fragment, null), React.createElement(DropdownItem, {
    name: paymentTypes.BANKCARD,
    selected: selectedDepositMethod === paymentTypes.BANKCARD
  }, React.createElement(Icon, {
    color: "fc-navy",
    icon: "creditcard"
  }), React.createElement(DropdownLabel, null, "Bankkort")), React.createElement(DropdownItem, {
    name: paymentTypes.SWEDBANKEXPRESS,
    selected: selectedDepositMethod === paymentTypes.SWEDBANKEXPRESS
  }, React.createElement(Bank, {
    className: "bank-container",
    height: 24,
    name: "swedbank-sparbankerna"
  }), React.createElement(DropdownLabel, null, "Direkt fr\xE5n ditt bankkonto"))))), blockInfo !== null && !blockInfo && React.createElement("div", null, selectedDepositMethod === paymentTypes.BANKCARD && React.createElement(BankCard, {
    isPlayerRegistration: isPlayerRegistration,
    ref: bankCardComponentRef,
    swedbankPayProps: swedbankPayProps
  }), selectedDepositMethod === paymentTypes.APPLEPAY && React.createElement(ApplePay, {
    isPlayerRegistration: isPlayerRegistration,
    ref: applePayComponentRef,
    swedbankPayProps: swedbankPayProps
  }), selectedDepositMethod === paymentTypes.SWISH && React.createElement(Swish, {
    handleSelect: handleSelect,
    hasNoProfileLinkSwish: hasNoProfileLinkSwish,
    isPlayerRegistration: isPlayerRegistration,
    setIsCheckBlock: setIsCheckBlock
  }), selectedDepositMethod === paymentTypes.SWEDBANKEXPRESS && React.createElement(SwedbankExpress, {
    isPlayerRegistration: isPlayerRegistration
  }), !selectedDepositMethod && isPlayerRegistration && React.createElement(WithdrawalInfo, null)), !isHideDepositLimits && blockInfo !== null && (blockInfo === false || (blockInfo === null || blockInfo === void 0 || (_blockInfo$depositRes = blockInfo.depositRestrictions) === null || _blockInfo$depositRes === void 0 ? void 0 : _blockInfo$depositRes.showFirstDialog)) && React.createElement(DepositLimits, null)), !isHideDepositLimits && !isTransactionsLimitsSet && React.createElement("div", {
    className: "transaction-deposit margin-top-4"
  }, React.createElement(InlineMessage, {
    actions: [{
      handleClick: handleNavigateToDepositLimits,
      text: 'Sätt insättningsgränser'
    }],
    buttonOptions: {
      block: true,
      transparent: true
    },
    header: "Ins\xE4ttningsgr\xE4nser",
    icon: "deposit-limits"
  }, "Innan du s\xE4tter in pengar m\xE5ste du s\xE4tta dina ins\xE4ttningsgr\xE4nser. Ins\xE4ttningsgr\xE4nser \xE4r ett lagkrav och ger dig b\xE4ttre koll p\xE5 dina ins\xE4ttningar och ditt spelande.")));
};
svs.accountservicesReact.deposit.DepositComponent = DepositComponent;

 })(window);